import useSWR from 'swr';
import type { AxiosError } from 'axios';
import axios from 'axios';

import type { ILabelValuePair } from '../../components/marking/MarkingInterfaces';

interface IRuleValues extends ILabelValuePair {
  workflowName: string;
}

const GetRuleOutcomeValues = (workflowName: string): {
  outcomeValues: IRuleValues[] | undefined,
  isLoading: boolean,
  isError: boolean,
} => {
  const fetcher = (url: string) => axios.get<IRuleValues[]>(url)
    .then((response) => response.data);

  const { data, error } = useSWR<IRuleValues[], AxiosError>('/policy/getOutcomeValues',
    (url) => fetcher(url));

  return {
    outcomeValues: data?.filter((d) => d.workflowName === workflowName.split(' - ')[0]),
    isLoading: !error && !data,
    isError: Boolean(error),
  };
};

export default GetRuleOutcomeValues;
